import { render, staticRenderFns } from "./Back.vue?vue&type=template&id=6c079583&scoped=true&"
var script = {}
import style0 from "./Back.vue?vue&type=style&index=0&id=6c079583&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c079583",
  null
  
)

export default component.exports